(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 50008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(10461);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/index.ts + 4 modules
var page_layout = __webpack_require__(80264);
;// CONCATENATED MODULE: ./assets/faqs/header-image.webp
/* harmony default export */ var header_image = ({"src":"/_next/static/media/header-image.037ee8c5.webp","height":1000,"width":1736,"blurDataURL":"data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAACwAQCdASoIAAUAAkA4JYgCdADze7hYAP7zYRUxuZhu/o4eNXntD9Yg0Oet3qSMK+J2eTfbKA74boUAAAA=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./components/accordion-list/index.ts + 5 modules
var accordion_list = __webpack_require__(98736);
;// CONCATENATED MODULE: ./pages/faq.tsx







var FAQ = function(param) {
    var globalLayoutProps = param.globalLayoutProps, faqs = param.faqs, pageContent = param.pageContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContent), {
            image: header_image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "faq-page-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_list/* default */.Z, {
                    items: faqs,
                    getId: function(item) {
                        return String(item.id);
                    },
                    getTitle: function(item) {
                        return item.title;
                    },
                    getContent: function(item) {
                        return item.text;
                    }
                })
            })
        }))
    }));
};
var __N_SSG = true;
/* harmony default export */ var faq = (FAQ);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5156,4520,4713,9774,2888,179], function() { return __webpack_exec__(50008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);